<template>
	<div>
		<Breadcrumbs main="country.resource" title="country.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div>
            <div v-show="process === 'add'" class="row ">
                <div id="addPort" class="col-sm-12 gradient-wy">
                    <div class="d-flex flex-row justify-content-between mx-1">
                        <div class="row ml-3" v-b-hover="handleHover">
                            <h2 class="text-primary mt-3">{{ $t('country.add') }}</h2>
                            <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                            <span v-show="isHovered" class="text-danger">{{ $t('port.cancelReturn')  }} </span>
                        </div>
                    </div>
                    <form class="theme-form">
                        <div class="row ml-2">
                            <div class="col-sm-2" role="group">
                                <label for="id" class="col-form-label pt-0 f-w-600"  style="font-size:16px;">{{$t("country.cntryId") }}</label>
                                <b-form-input
                                    id="id"
                                    style="font-size:16px;" 
                                    v-model="id"
                                    type="text"
                                    :state="idState"
                                    :formatter="formatter"
                                    aria-describedby="input-live-help-id input-live-feedback-id"
                                    :placeholder="$t('country.cntryIdPh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback-id"> {{ $t("country.cntryId2CapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help-id">{{ $t("country.cntryIdHelp") }}</b-form-text>           
                            </div>                       

                            <div class="col-sm-4" role="group">
                                <label for="cntry" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("country.cntry") }}</label>
                                <b-form-input
                                    id="cntry"
                                    style="font-size:16px;" 
                                    v-model="cntry"
                                    type="text"
                                    :formatter="formatter"
                                    aria-describedby="input-live-help-cntry input-live-feedback-cntry"
                                    :placeholder="$t('country.cntryPh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback-cntry"> {{ $t("port.cntryCapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help-cntry">{{ $t("country.cntryHelp") }}</b-form-text>           
                            </div>  
                            <div class="col-sm-12" role="group">
                                <label for="srvScp" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("country.srvScp") }}</label>
                                <b-form-input
                                    id="cntry"
                                    style="font-size:16px;" 
                                    v-model="srvScp"
                                    type="text"
                                    :formatter="formatter"
                                    aria-describedby="input-live-help-srvScp input-live-feedback-srvScp"
                                    :placeholder="$t('country.srvScpPh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback-srvScp"> {{ $t("country.srvScpCapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help-srvScp">{{ $t("country.srvScpHelp") }}</b-form-text>           
                            </div>  
                            <div class="col-sm-1 mt-4">
                                <b-button  style="font-size:20px"  type="button" @click="handleSave">{{ $t('container.save') }}</b-button>
                            </div>
                            <div class="col-sm-1 mt-4">
                                <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                            </div> 
                        </div>
                    </form>
                </div>
            </div>
            <div v-show="process === 'update' " class="row">
                <div class="col-sm-12 gradient-ow">
                    <div class="row ml-3" v-b-hover="handleHover">
                        <h3 class="text-primary mt-3">{{ $t('port.edit') }}</h3>
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcess">&times;</span>
                        <span v-show="isHovered" class="text-danger">{{ $t('port.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form">
                        <div class="row">
                            <div class="col-sm-2" role="group">
                                <label for="id" class="col-form-label pt-0 f-w-600"  style="font-size:16px;">{{$t("country.cntryId") }}</label>
                                <b-form-input
                                    id="id"
                                    style="font-size:16px;" 
                                    v-model="id"
                                    type="text"
                                    disabled
                                >
                                </b-form-input>      
                            </div>                       
                            <div class="col-sm-4" role="group">
                                <label for="cntry" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("country.cntry") }}</label>
                                <b-form-input
                                    id="cntry"
                                    style="font-size:16px;" 
                                    v-model="cntry"
                                    type="text"
                                    :formatter="formatter"
                                    :placeholder="$t('country.cntryPh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback"> {{ $t("country.cntryCapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help">{{ $t("country.cntryHelp") }}</b-form-text>           
                            </div>  
                            <div class="col-sm-12" role="group">
                                <label for="srvScp" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("country.srvScp") }}</label>
                                <b-form-input
                                    id="srvScp"
                                    style="font-size:16px;" 
                                    v-model="srvScp"
                                    type="text"
                                    :formatter="formatter"
                                    :placeholder="$t('country.srvScpPh')"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="input-live-feedback"> {{ $t("country.cntryCapitalChrAllow") }}</b-form-invalid-feedback>
                                <b-form-text id="input-live-help">{{ $t("country.cntryHelp") }}</b-form-text>           
                            </div> 
                            <div class="col-sm-1 mt-4">
                                <button class="btn btn-warning btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('container.update') }}</button>
                            </div>
                            <div class="col-sm-1 mt-4">
                                <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                            </div> 
                        </div>


                    </form>
                </div>
            </div>                
                <div class="divider"> </div>                    
                <div class="row">
                    <h2 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('country.cntryList') }}</h2>
                    <b-button v-show="process === 'info'" pill href="#addPort" size="sm" @click="process = 'add' " class="bg-primary mb-4 mt-3 ml-3 ">
                        <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('country.add') }} </span>
                    </b-button>            
                    <b-col lg="3" class="ml-3 mt-3">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" class="my-1">
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="mt-1 text-info"
                            plain
                        >
                            <b-form-checkbox value="id">{{ $t('country.cntryId') }}</b-form-checkbox>                                                                
                            <b-form-checkbox value="cntry">{{ $t('country.cntry') }}</b-form-checkbox>
                            <b-form-checkbox value="cntryCode">{{ $t('cntry.srvScp') }}</b-form-checkbox>                               
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync= "sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(actions)="row" >
                        <b-button pill size="sm" @click="actUpdate(row.item)" class="m-1 btn-warning">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.update') }}</span>
                        </b-button>
                        <b-button pill size="sm" @click="actDelete(row.item)" class="m-1 btn-danger">
                            <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.delete') }}</span>
                        </b-button>                        
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { getDataAll, saveWithId, deleteItem} from "../../firebase"

export default {
	data(){
		return{
            process : "info",
            isHovered: false,
            id : '',
            srvScp : '',
            cntry : '',
            items: [],
            fields: [
                { key: 'id', label: this.$t('country.cntryId'), sortable: true, variant: 'primary'},  
                { key: 'cntry', label: this.$t('country.cntry'), sortable: true , variant: 'info'},  
                { key: 'srvScp', label: this.$t('country.srvScp'), sortable: true , variant: 'success'},                
                { key: 'actions', label: this.$t('matchTx.actions'), variant: 'warning'},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'cntry',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
		}
	},

    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      idState() {
            return this.id.length == 2 ? true : false
        }
    },
	mounted(){
        getDataAll( "Country", (res)=>{
            this.items = res
            this.totalRows = res.length
        })
	},
	methods:{
 
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },        
        handleHover(hovered) {
            this.isHovered = hovered
        },
        formatter(value) {
            return value.toUpperCase()
        },
        clickCancelProcess(){
            this.process = 'info'
            this.refresh()
        },
        async saveCntry(){

                let payload = {
                    id : this.id,
                    cntry : this.cntry.trim(),
                    srvScp: this.srvScp,
                }
                await saveWithId('Country', this.id, payload).then(async()=>{
                    await this.refresh()
                    this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
                })
         
        },
        async handleSave(){
            let msg = 'completed'
            if (this.id ==='') {
                msg = 'country.addCntryId'
            } else if (this.cntry ===''){
                msg = 'port.addCntryName'
            } else if (this.srvScp ===''){
                msg = 'port.addSrvScp'
            } 
            if (msg === 'completed'){
                 await this.saveCntry()                 
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "Country", item.id)
                    await this.refresh()                   
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async refresh(){
            await getDataAll( "Country", (res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.id = ''
            this.cntry = ''
            this.srvScp = ''
            this.process = 'info'
        },

        async handleUpdate(){
            let msg = 'completed'
            if (this.cntry ===''){
                msg = 'country.addCntryName'
            } else if (this.srvScp ===''){
                msg = 'country.addSrvScp'
            } 
            if (msg === 'completed'){
                await this.saveCntry()

            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        async actUpdate(item) {
            this.process = "update"   // to pop up Update subMenu
            this.id = item.id
            this.cntry = item.cntry.trim() 
            this.srvScp = item.srvScp
        }, 


    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-ow {
   background: linear-gradient(135deg, orange, white);
 }

.divider {
    height: 5px;
    background-color: #f10909;
    margin:5px
}
</style>
